<template>
  <div>
    <TableBlock ref="tableData" @checkVal="selectVal" :columns="columns" :topWidth="30" :action="action" :param="formData" :navHeight="487" :topHegiht="350">
      <div class="common-items-center common-space-between" style="margin-bottom: 16px;">
               <div class="common-items-center"> 
                  <el-input style="margin-right: 10px;width: 300px;" placeholder="产品名称/位置区域" v-model="formData.keywords"></el-input>
                  <el-button type="primary"  @click="serachBtn">查询</el-button>
                  <el-button   @click="resetBtn">重置</el-button>
               </div>
               <div>
               <el-button type="primary" class="add-btn" @click="operateShow(2)" style="padding:10px">导出</el-button>
              </div>
      </div>
    </TableBlock>
    <!-- <div class="common-items-center common-space-between" style="margin-bottom: 16px;">
      <div class="common-items-center">
        <InputBlock ref="keyWord" keyVal="keywords" right="20" paddButtom="0" @getVal="getVal" width="300"
          placeholder="请输入产品名称、位置区域" />
        <el-button type="primary"  @click="serachBtn">查询</el-button>
        <el-button 
          @click="resetBtn">重置</el-button>
           <el-button type="primary" class="add-btn" @click="addBtn" style="padding:10px">导出</el-button>
      </div>
      <div>
      </div>
    </div>
    <div class="warp-table">
      <el-table size="small" ref="giftTable" :data="tableData" :height="THeight"   row-key="id"
        @selection-change="checkSelectBtn">
        <el-table-column align="center" header-align="center" :show-overflow-tooltip="true" type="selection"
          width="60"></el-table-column>
        <el-table-column align="center" header-align="center" :show-overflow-tooltip="true" prop="resourcesUrl"
          label="产品图片" width="160">
          <template slot-scope="scope">
            <div>
              <img :src="scope.row.resourcesUrl" style="height:30px;width:30px;">
            </div>
          </template>
        </el-table-column>
        <el-table-column align="left" header-align="left" :show-overflow-tooltip="true" prop="productName"
          label="产品名称" ></el-table-column>
        <el-table-column align="left" header-align="left" :show-overflow-tooltip="true" prop="serialNo"
          label="序列号/IMEI" width="260"> </el-table-column>
        <el-table-column align="left" header-align="left" :show-overflow-tooltip="true" prop="address" label="位置安装区域"
          width="270"></el-table-column>
        <el-table-column align="left" header-align="left" :show-overflow-tooltip="true" prop="bindingTime"
          label="安装时间" width="170"></el-table-column>
        <el-table-column align="center" header-align="center" :show-overflow-tooltip="true" prop="isConstructionDrawing"
          width="150" label="状态"  >
          <template slot-scope="scope">
            <div>
              <span style="color:rgb(109, 221, 187)" v-if="scope.row.hasBingding * 1 == 1">已安装</span>
              <span style="color:red" v-else>未安装</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" header-align="center" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="scope.row.hasBingding * 1 == 1"  @click="operateShow(1, scope.row)">编辑&nbsp;</el-button>
            <el-button type="text" size="small" @click="operateShow(2, scope.row)">查看&nbsp;</el-button>
            <el-button type="text" v-if="scope.row.hasBingding * 1 == 1" size="small" @click="operateShow(3, scope.row)">解绑&nbsp;</el-button>
            <el-button type="text" v-if="scope.row.hasBingding * 1 != 1"  size="small" @click="operateShow(4, scope.row)">移除&nbsp;</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Paging @getPage="getPage" :total="total" :pageNo="current" :size="size" />
    </div>
    <el-dialog :show-close="true" :title="index == 1 ? '编辑' : '查看'" :visible.sync="isShow" :width="width"
      :close-on-click-modal="false">
      <edit v-if="index == 1" :device="row" :spaceList="threeList" ref="edit" :edits="edits"></edit>
      <query v-if="index == 2" ref="query" :edit="row" :deail="deail"></query>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShow = false">取 消</el-button>
        <el-button type="primary" v-if="index == 1" @click="click">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import { scroll } from '@/components/component-mixin/block-scroll'
import {downFile} from '@/utils/util'
import {operate} from '@/utils/config'
import {columns} from './clumns'
import { postFun } from '@/utils/httpFun'
import query from './block_dev_query.vue'
import edit from './block_dev_edit.vue'
import axios from 'axios'
import { getFun } from '@/utils/httpFun'

export default {
  name: 'index',
  mixins: [scroll],
  components: {
    query,
    edit
  },
  props: ['edits'],
  data: () => ({
    action:operate.GETDEVICELIST,
    columns:'',
    tableData: [],
    formData: {
      projectId: '',
      keywords: null,
    },
    THeight:0,
    list: [
      { indexNo: '1', selectName: '有' },
      { indexNo: '0', selectName: '无' }
    ],
    row: {},
    isShow: false,
    index: 1,
    width: '28%',
    deail: {},
    threeList: {},
    deviceList:{}
  }),
  created() {
    console.log("创建", this.edits)
    this.columns = columns(this);
    this.THeight = this.$store.state.windowHeight-420
    this.formData.projectId = this.edits.id;
    this.getDatas()
    this.$bus.$off('device-getData');
    this.$bus.$on('device-getData', res => {
      this.index = -1;
      this.getDatas();
    })

  },
  methods: {
    selectVal(e){
      this.deviceList = e;
    },
    click() {
      this.isShow = false;
      if (this.index == 1) {
        this.$refs.edit.edit();
      }
    },
    fileExport(){

      let devices = [];

      this.deviceList.forEach(item=>{
        devices.push(item.deviceId);
      })

      let param = {
        ...this.formData,
        deviceIds:devices
      }

      axios({
        method:'post',
        headers: { 'Authorization':localStorage.getItem('YunWeiTikenBRJ') },
        responseType: 'arraybuffer',
        url:operate.EXPORTDEV,
        data:param
      }).then(res=>{
        console.log('导出项目设备管理',res)
        if(!!res && res.status == 200){
          downFile(res.data,'项目设备管理','xlsx')
        }else if(!!res){
          this.$message.warning(res.message)
        }
      }).catch(err=>{
        console.log('报错',err);
        this.$message.warning(err.message);
      })
    },
    // 操作
    operateShow(index, row) {
      this.index = index;
      switch (index) {
        case 1:
          getFun(url.PROJECT.SPACESTRUCTURE + '?projectId=' + this.edits.id, {}, res => {
            this.row = row;
            this.threeList = res.data == null || res.data == undefined ? [] : res.data;
            this.isShow = true;
            this.width = '28%'
          })
          break;
        case 2:
          this.fileExport()
          break;
        case 3:
          // UNBINDING
          this.$confirm('是否解绑该设备?', '解绑', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            getFun(url.PROJECT.UNBINDING + '?deviceId=' + row.deviceId, {}, res => {
              if (res.data) {
                this.$message({
                  type: 'success',
                  message: '解绑成功!'
                });
              } else {
                this.$message.warning('解绑失败')
              }

              this.getDatas();
            })
          })
          break;
        case 4:
          this.$confirm('是否移除?', '移除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            getFun(url.PROJECT.REMOVEDEV + '?deviceId=' + row.deviceId, {}, res => {
              if (res.data) {
                this.$message({
                  type: 'success',
                  message: '移除成功!'
                });
              } else {
                this.$message.warning('移除失败')
              }

              this.getDatas();
            })
          })
          break;
      }
    },
    //获取所有的数据
    async getDatas() {
      let parms = {
        param: {
          ...this.formData
          // keyWord: this.formData.keyWord,
        },
        current: this.current,
        size: this.size
      }
      await postFun(url.PROJECT.GETDEVICEPAGE, parms, res => {
        if (!res.data) {
          this.tableData = []
        } else {
          this.tableData = res.data.records
          this.total = res.data.total
          this.size = res.data.size
          this.current = res.data.current
        }
      })
    },
    getVal(e) {
      console.log("输入", e)
      this.formData.keywords = e.val;
    },
    //查询
    serachBtn() {
      this.tableData = []
      this.$nextTick(res=>{
           this.$refs.tableData.getDatas() 
       })
    },

    //重置
    resetBtn() {
      this.tableData = []
      this.formData.keywords = null;
      this.$nextTick(res=>{
           this.$refs.tableData.resetHttp() 
       })
    },
    //多选
    checkSelectBtn(ev) {

    },
    //分页
    getPage(ev) {
      this.size = ev.pageSize
      this.current = ev.pageNo
      this.getDatas()
    },
  }
}
</script>

<style lang="scss" scoped>
.warp-btn {
  display: flex;
  justify-content: flex-start;
}

.right-div {
  height: 300px;
  border-radius: 4px;
  padding: 15px;
  box-sizing: border-box;

  .warp-table {
    padding-top: 10px;
  }
}

::v-deep .el-dialog__header {
  height: 23px;
  background: #F8F9FA;
  box-shadow: 0px 1px 0px 0px rgb(237 238 240);
  border-radius: 12px 12px 0 0;
}

::v-deep .el-dialog {
  border-radius: 12px;
}</style>